import React from 'react'
import ReactDOM from 'react-dom'
import App from './App.jsx'
import './patch_sdp'

ReactDOM.render(<App />, document.getElementById('root'))
